var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('content-header'),_c('content-container',[_c('tab-container',{attrs:{"items":_vm.tabItems}},[_vm._l((_vm.tabItems),function(tabItem){return _c('template',{slot:tabItem.data},[_c(tabItem.data,{key:tabItem.data,tag:"component"})],1)})],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }